<template>
  <div class="menubox">
    <ul class="menu-ul">
      <li class="menu-li">
        <a href="JavaScript:;" @click="$router.push('/')">首页</a>
      </li>
      <li class="menu-li">
        <a href="JavaScript:;" @click="$router.push('/project-find')">资源匹配</a>
      </li>
      <li class="menu-li">
        <a href="JavaScript:;" @click="$router.push('/organization')">数字化转型</a>
      </li>
      <li class="menu-li">
        <a href="JavaScript:;" @click="$router.push('/scene')">云上直播</a>
      </li>
      <li class="menu-li">
        <a href="JavaScript:;" @click="$router.push('/oneroad').catch(()=>{})">一带一路</a>
      </li>
     <!-- <li class="menu-li">
        <a href="JavaScript:;" @click="$router.push('/difangchanye')">地方产业</a>
      </li> -->
      <li class="menu-li">
         <a href="JavaScript:;" @click="$router.push('/personal-center/org')">新基建产品与服务认定</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Nav',
  props: {
    msg: String,
  },
};
</script>

<style>
@import url(./Nav.css);
</style>
